let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("490Jr")).then(() => parcelRequire('go9q2'));